
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reports/usage",
      function () {
        return require("private-next-pages/reports/usage/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reports/usage"])
      });
    }
  